import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
  colors: {
    white: '#FAFAFA',
    gray6: '#eaeaea',
    gray5: '#D2D2D2',
    gray4: '#9093A1',
    gray3: '#6D7284',
    gray2: '#454A51',
    gray1: '#282B30',
    bar: '#2c2c2f',
    background: '#EFF2F5',
    green: '#03C869',
    alertHigh: '#CE2D5E',
    alertMedium: '#ED813B',
    alertLow: '#E5C35D',
    scoreHigh: '#0063F7',
    scoreMedium: '#63A2FF',
    scoreLow: '#AECFFF',
  },
  fonts: {
    regular: 'BarlowRegular',
    rajdhaniMedium: 'RajdhaniMedium',
  },
  fontSize: {
    s56: '56px',
    s50: '50px',
    s40: '40px',
    s38: '38px',
    s35: '35px',
    s30: '30px',
    s32: '32px',
    s25: '25px',
    s22: '22px',
    s20: '20px',
    s18: '18px',
    s16: '16px',
    s14: '14px',
    s12: '12px',
  },
}

export default theme
